export enum CopilotDropzone {
  None = 'None',
  Left = 'Left',
  Right = 'Right',
}
export enum ChatStatus {
  Idle = 'Idle',
  InProgress = 'InProgress',
  Cancelling = 'Cancelling',
  AwaitingFeedback = 'AwaitingFeedback',
}

export enum ChatItemType {
  User = 'User',
  AgentSwitch = 'AgentSwitch',
  Cancellation = 'Cancellation',
  Assistant = 'Assistant',
  RoutingEnded = 'RoutingEnded',
  AgentSessionSummaryEnded = 'AgentSessionSummaryEnded',
  ClassificationEnded = 'ClassificationEnded',
  UploadAndAnalyzeDraftFilesEnded = 'UploadAndAnalyzeDraftFilesEnded',
  AgentInvocation = 'AgentInvocation',
}

export enum ChatItemPartType {
  Plaintext = 'plaintext',
  Widget = 'widget',
}

export enum CopilotWidgetType {
  // example widgets
  RenameWidget = 'rename-widget',
  ShowBooksWidget = 'show-books-widget',

  // real widgets
  InlineWidget = 'inline-widget',
  ExcelToCampaignSummary = 'excel-to-campaign-summary',
  BatchRenameWidget = 'batch-rename-widget',
  AssetDisplayAndSelectWidget = 'asset-display-and-select-widget',
  AssetSelectorWidget = 'asset-selector-widget',
  UserConfirmationWidget = 'user-confirmation-widget',
  PlanWidget = 'plan-widget',
}

export enum CopilotFileContentType {
  Unknown = 'Unknown',
  Excel = 'Excel',
}

export enum AgentName {
  General = 'copilot',
  Support = 'support',
  CampaignsManager = 'campaigns-manager',
  CampaignSetup = 'campaign-setup',
  SocialCampaignSetup = 'social-campaign-setup',
  Strategy = 'strategy',
  ExcelToCampaign = 'excel-to-campaign',
  CreativeTemplatesManager = 'creative-templates-manager',
  CreativesManager = 'creatives-manager',
  AdBuilder = 'ad-builder',
  TemplateMapping = 'template-mapping',
  CampaignAnalytics = 'campaign-analytics',
  BrandGuidelines = 'brand-guidelines',
  BasicAgent = 'basic-agent',
  AccountAnalytics = 'account-analytics',
  AiContentProjectAgent = 'ai-content-project',
}

export enum BlockingWidgetDisplayMode {
  Inline = 'Inline',
  Modal = 'Modal',
}

export enum ToolResultPayloadType {
  Knowledge = 'knowledge',
  Resource = 'resource',
}

export enum RagSearchResponseAnswerType {
  Partial = 'partial-answer',
  Full = 'full-answer',
  NoAnswer = 'no-answer',
  QuestionNeedsClarification = 'question-needs-clarification',
  IrrelevantQuestion = 'irrelevant-question',
}

export enum ToolName {
  GetFiles = 'get-files',
  GeneralKnowledge = 'general-knowledge',
  ResourceKnowledge = 'resource-knowledge',
  FilterTable = 'filter-table',
  GeneralNavigation = 'general-navigation',
  AskKnowledgeRAG = 'ask-knowledge-rag',
  ReadExcelWorksheet = 'read-excel-worksheet',
  AnalyzeExcelHeaders = 'analyze-excel-headers',
  SelectAssets = 'select-assets',
}

export enum LLMResponseType {
  Content = 'content',
}

export enum ErrorType {
  General = 'general',
  Tool = 'tool',
}

export enum AgentRequestClassification {
  KnowledgeQuery = 'KNOWLEDGE_QUERY',
  UserChat = 'USER_CHAT',
  SimpleAction = 'SIMPLE_ACTION',
  ComplexAction = 'COMPLEX_ACTION',
  CannotHandle = 'CANNOT_HANDLE',
}

export enum EntityTypeToRename {
  Campaign = 'Campaign',
  Template = 'Template',
  Creative = 'Creative',
}

export enum FileExtension {
  XLSX = 'xlsx',
  XLS = 'xls',
}

export enum CallerType {
  Copilot = 'Copilot',
  Agent = 'Agent',
  Tool = 'Tool',
  Custom = 'Custom',
}

export enum EventType {
  ToolCallsStarted = 'ToolCallsStarted',
  ToolCallStarted = 'ToolCallStarted',
  ToolCallEnded = 'ToolCallEnded',
  RoutingStarted = 'RoutingStarted',
  RoutingEnded = 'RoutingEnded',
  AgentSessionSummaryStarted = 'AgentSessionSummaryStarted',
  AgentSessionSummaryEnded = 'AgentSessionSummaryEnded',
  Log = 'Log',
  AskStarted = 'AskStarted',
  AskEnded = 'AskEnded',
  InitiateExecutePlanStarted = 'InitiateExecutePlanStarted',
  InitiateExecutePlanEnded = 'InitiateExecutePlanEnded',
  PlanCancellationStarted = 'PlanCancellationStarted',
  PlanCancellationEnded = 'PlanCancellationEnded',
  PlanFinished = 'PlanFinished',
  RequestUserFeedbackStarted = 'RequestUserFeedbackStarted',
  RequestUserFeedbackEnded = 'RequestUserFeedbackEnded',
  CancellationStarted = 'CancellationStarted',
  CancellationEnded = 'CancellationEnded',
  UploadAndAnalyzeDraftFilesStarted = 'UploadAndAnalyzeDraftFilesStarted',
  UploadAndAnalyzeDraftFilesEnded = 'UploadAndAnalyzeDraftFilesEnded',
  StandaloneLLMCallStarted = 'StandaloneLLMCallStarted',
  StandaloneLLMCallEnded = 'StandaloneLLMCallEnded',
  LLMCallStarted = 'LLMCallStarted',
  LLMCallEnded = 'LLMCallEnded',
  InvokeAgentStarted = 'InvokeAgentStarted',
  InvokeAgentEnded = 'InvokeAgentEnded',
  ClassificationStarted = 'ClassificationStarted',
  ClassificationEnded = 'ClassificationEnded',
  HandoffStarted = 'HandoffStarted',
  HandoffEnded = 'HandoffEnded',
}

export enum LogLevel {
  Log = 'log',
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

export enum AgentInvocationChatItemNodeType {
  Agent = 'Agent',
  LLMCall = 'LLMCall',
  ToolCalls = 'ToolCalls',
  ToolCall = 'ToolCall',
}
